<template>
    <div>
        <div class="myprofile-wrapper" v-if="mobileCheck">
            <v-select
                :items="tabsList"
                item-text="value"
                item-value="id"
                v-model="selectedTab"
                v-on:change="val => selectedTab = val"
                class="mobile-select"
            ></v-select>

            <div class="myprofile-container" v-if="selectedTab === 0">
                <PortfolioScreenMobile></PortfolioScreenMobile>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 12">
                <SoldWinesScreenMobile
                    @triggerSalesInvoiceDetailsPage="onOpenSalesOrderDetailsPageFunc"></SoldWinesScreenMobile>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 2">
                <BidsOffersScreenMobile></BidsOffersScreenMobile>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 1 && (userData.mangopayStatus === 2 || userData.mangopayStatus === 3)">
                <Wallet></Wallet>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 3">
                <Favourites></Favourites>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 4">
                <Notifications></Notifications>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 5">
                <div class="myprofile-container">
                    <div class="myprofile-inner-container">
                        <v-form ref="form" v-model="valid" class="change-pass-form">
                            <div class="success-alert" v-if="userDetailsUpdatedSuccess">
                                User details updated successfully
                            </div>
                            <div class="fail-alert" v-if="userDetailsUpdatedFail">
                                There was an error while trying to update your details
                            </div>
                            <v-flex>
                                <span class="myprofile-label">{{ $t('myprofile1') }}</span>
                                <v-text-field v-model="userData.firstName" :rules="[rules.required]"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="myprofile-label">{{ $t('myprofile2') }}</span>
                                <v-text-field v-model="userData.lastName" :rules="[rules.required]"></v-text-field>
                            </v-flex>
                            <v-flex class="myacc-email-container">
                                <span class="myprofile-label">Email <span>*</span></span>
                                <v-text-field v-model="userData.email" disabled></v-text-field>
                            </v-flex>
                            <v-flex class="myacc-email-container">
                                <span class="myprofile-label">{{ $t('myprofile4') }}</span>
                                <v-text-field v-model="userData.phoneNumber" :rules="[rules.required]"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="myprofile-label">Gender</span>
                                <v-select
                                    :items="genders"
                                    placeholder="Choose gender"
                                    item-text="value"
                                    item-value="id"
                                    v-model="userData.gender"
                                ></v-select>
                            </v-flex>
                            <v-flex style="position: relative;">
                                <span class="myprofile-label myprofile-label-date">{{ $t('myprofile6') }}</span>
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                    :rules="[rules.required]"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="dateOfBirth"
                                            readonly
                                            v-on="on"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="userData.dateOfBirth" no-title scrollable
                                                   :rules="[rules.required]">
                                        <div class="flex-grow-1"></div>
                                        <v-btn text color="primary" @click="menu = false">{{ $t('cancel') }}</v-btn>
                                        <v-btn text color="primary" @click="$refs.menu.save(userData.dateOfBirth)">OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex v-if="vin_countries.length" class="country-container myprofile-country">
                                <span class="myprofile-label">{{ $t('wallet055') }} *</span>
                                <country-select class="country-select" v-model="country" :whiteList="vin_countries"
                                                :class="countryError ? 'error-msg' : ''" :country="country"
                                                :rules="[rules.required]"/>
                                <div v-if="countryError" class="v-text-field__details">
                                    <div class="v-messages theme--light error--text">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">Required.</div>
                                        </div>
                                    </div>
                                </div>
                            </v-flex>

                            <v-flex v-if="vin_countries.length" class="country-container myprofile-country">
                                <span class="myprofile-label">{{ $t('wallet054') }} *</span>
                                <country-select class="country-select" v-model="nationality" :whiteList="vin_countries"
                                                :class="nationalityError ? 'error-msg' : ''" :country="nationality"
                                                :rules="[rules.required]"/>
                                <div v-if="nationalityError" class="v-text-field__details">
                                    <div class="v-messages theme--light error--text">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">Required.</div>
                                        </div>
                                    </div>
                                </div>
                            </v-flex>
                        </v-form>
                    </div>
                </div>
                <v-btn class="submit myprofile-submit" v-on:click="updateDetails" text :disabled="!valid">
                    {{ $t('change-password3') }}
                </v-btn>
                <button class="reset-btn" v-on:click="showResetModal = true">
                    Reset
                    <div class="link-border"></div>
                </button>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 6">
                <Addressbook></Addressbook>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 7">
                <BankDetails></BankDetails>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 8">
                <div class="myprofile-container">
                    <div class="myprofile-inner-container">
                        <div class="success-alert" v-if="passwordChangeSuccess">
                            Password updated successfully
                        </div>
                        <div class="fail-alert" v-if="passwordChangeFail.visible">
                            {{ passwordChangeFail.text }}
                        </div>
                        <v-form ref="form" v-model="valid2" class="change-pass-form" v-if="!passwordChangeSuccess">
                            <v-flex class="input-wrapper">
                                <span class="myprofile-label">{{ $t('change-password1') }}</span>
                                <v-text-field
                                    v-model="currentPassword"
                                    :append-icon="secureTextPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="secureTextPassword ? 'password' : 'text'"
                                    name="input-10-1"
                                    hint="At least 8 characters"
                                    counter
                                    @click:append="secureTextPassword = !secureTextPassword"
                                ></v-text-field>
                            </v-flex>
                            <v-flex class="input-wrapper">
                                <span class="myprofile-label">{{ $t('change-password2') }}</span>
                                <v-text-field
                                    v-model="newPassword"
                                    :append-icon="secureTextNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min, rules.samePassword]"
                                    :type="secureTextNewPassword ? 'password' : 'text'"
                                    name="input-10-1"
                                    hint="At least 8 characters"
                                    counter
                                    @click:append="secureTextNewPassword = !secureTextNewPassword"
                                ></v-text-field>
                            </v-flex>
                        </v-form>
                    </div>
                    <v-btn class="submit-change-pass-btn submit" text v-on:click="changePassword" :disabled="!valid2"
                           v-if="!passwordChangeSuccess">{{ $t('change-password3') }}
                    </v-btn>
                </div>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 9">
                <Invoices></Invoices>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 10">
                <TradesHistory></TradesHistory>
            </div>
            <div class="myprofile-container" v-if="selectedTab === 11">
                <SaleOrders :selectedSaleInvoiceId="selectedSaleInvoiceId"
                            @triggerBackToSoldWinesPage="onTriggerBackToSoldWinesPage"></SaleOrders>
            </div>
        </div>

        <div class="myprofile-wrapper" v-else>
            <div class="no-fav" v-if="!isLogged">
                <div>Join Vindome to start building your collection of favourite wines</div>
                <button class="btn-primary goto-market-btn" v-on:click="() => goToLogin()">Join Vindome</button>
            </div>

            <v-tabs vertical class="my-profile-vertical-tabs" v-else v-model="selectedTab">
                <div class="profile-name" v-if="userData.firstName">{{ profileName }}</div>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu1') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop" v-if="userData.mangopayStatus === 2 || userData.mangopayStatus === 3">
                    <div class="vertical-tabs-label">Wallet</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu2') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu3') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu4') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu5') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu6') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu7') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu8') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu9') }}</div>
                </v-tab>
                <v-tab v-on:click="scrollToTop">
                    <div class="vertical-tabs-label">{{ $t('my-account-menu10') }}</div>
                </v-tab>
                <!--                    <v-tab>-->
                <!--                        <div class="vertical-tabs-label">Delivery orders</div>-->
                <!--                    </v-tab>-->
                <div class="vertical-tabs-label vertical-tabs-logout" v-on:click="logout">{{
                        $t('my-account-menu11')
                    }}
                </div>
                <div style="display: none">
                    <client-only>
                        <v-facebook-login app-id="4547708611999159" @sdk-init="handleSdkInit">
                            <button slot="login">Sign in with Facebook</button>
                        </v-facebook-login>
                    </client-only>
                </div>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('my-account-menu1') }}</h2>
                                <PortfolioScreen @triggerSalesInvoiceDetailsPage="onOpenSalesOrderDetailsPageFunc"
                                                 :preselectedTab="preselectedTab"></PortfolioScreen>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item v-if="userData.mangopayStatus === 2 || userData.mangopayStatus === 3">
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>Wallet</h2>
                                <Wallet></Wallet>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('my-account-menu2') }}</h2>
                                <Favourites></Favourites>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('notifications0') }}</h2>
                                <Notifications></Notifications>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('my-account-menu4') }}</h2>
                                <div class="myprofile-inner-container">
                                    <v-form ref="form" v-model="valid" class="change-pass-form">
                                        <div class="success-alert" v-if="userDetailsUpdatedSuccess">
                                            User details updated successfully
                                        </div>
                                        <div class="fail-alert" v-if="userDetailsUpdatedFail">
                                            There was an error while trying to update your details
                                        </div>
                                        <v-flex>
                                            <span class="myprofile-label">{{ $t('myprofile1') }} <span
                                                style="color: red">*</span></span>
                                            <v-text-field v-model="userData.firstName"
                                                          :rules="[rules.required]"></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <span class="myprofile-label">{{ $t('myprofile2') }} <span
                                                style="color: red">*</span></span>
                                            <v-text-field v-model="userData.lastName"
                                                          :rules="[rules.required]"></v-text-field>
                                        </v-flex>
                                        <v-flex class="myacc-email-container">
                                            <span class="myprofile-label">Email <span style="color: red">*</span></span>
                                            <v-text-field v-model="userData.email" disabled></v-text-field>
                                        </v-flex>
                                        <v-flex class="myacc-email-container">
                                            <span class="myprofile-label">{{ $t('myprofile4') }}</span>
                                            <v-text-field v-model="userData.phoneNumber"></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <span class="myprofile-label">Gender</span>
                                            <v-select
                                                :items="genders"
                                                placeholder="Choose gender"
                                                item-text="value"
                                                item-value="id"
                                                v-model="userData.gender"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex style="position: relative;">
                                            <span class="myprofile-label myprofile-label-date">{{
                                                    $t('myprofile6')
                                                }}</span>
                                            <v-menu
                                                ref="menu"
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                                :rules="[rules.required]"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="dateOfBirth"
                                                        readonly
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="userData.dateOfBirth" no-title scrollable>
                                                    <div class="flex-grow-1"></div>
                                                    <v-btn text color="primary" @click="menu = false">{{
                                                            $t('cancel')
                                                        }}
                                                    </v-btn>
                                                    <v-btn text color="primary"
                                                           @click="$refs.menu.save(userData.dateOfBirth)">OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex v-if="vin_countries.length" class="country-container myprofile-country">
                                            <span class="myprofile-label">{{ $t('wallet055') }} *</span>
                                            <country-select class="country-select" v-model="country"
                                                            :whiteList="vin_countries"
                                                            :class="countryError ? 'error-msg' : ''" :country="country"
                                                            :rules="[rules.required]"/>
                                            <div v-if="countryError" class="v-text-field__details">
                                                <div class="v-messages theme--light error--text">
                                                    <div class="v-messages__wrapper">
                                                        <div class="v-messages__message">Required.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-flex>

                                        <v-flex v-if="vin_countries.length" class="country-container myprofile-country">
                                            <span class="myprofile-label">{{ $t('wallet054') }} *</span>
                                            <country-select class="country-select" v-model="nationality"
                                                            :whiteList="vin_countries"
                                                            :class="countryError ? 'error-msg' : ''" :country="nationality"
                                                            :rules="[rules.required]"/>
                                            <div v-if="nationalityError" class="v-text-field__details">
                                                <div class="v-messages theme--light error--text">
                                                    <div class="v-messages__wrapper">
                                                        <div class="v-messages__message">Required.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-flex>
                                    </v-form>
                                </div>
                            </div>
                            <v-btn class="submit myprofile-submit" v-on:click="updateDetails" text :disabled="!valid">{{ $t('change-password3') }}</v-btn>
                            <button class="reset-btn" v-on:click="showResetModal = true">
                                Reset
                                <div class="link-border"></div>
                            </button>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('my-account-menu5') }}</h2>
                                <Addressbook></Addressbook>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('my-account-menu6') }}</h2>
                                <BankDetails></BankDetails>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('my-account-menu7') }}</h2>
                                <div class="myprofile-inner-container">
                                    <div class="success-alert" v-if="passwordChangeSuccess">
                                        Password update successfully
                                    </div>
                                    <div class="fail-alert" v-if="passwordChangeFail.visible">
                                        {{ passwordChangeFail.text }}
                                    </div>
                                    <v-form ref="form" v-model="valid2" class="change-pass-form"
                                            v-if="!passwordChangeSuccess">
                                        <v-flex class="input-wrapper">
                                            <span class="myprofile-label">{{ $t('change-password1') }}</span>
                                            <v-text-field
                                                v-model="currentPassword"
                                                :append-icon="secureTextPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                :rules="[rules.required, rules.min]"
                                                :type="secureTextPassword ? 'password' : 'text'"
                                                name="input-10-1"
                                                hint="At least 8 characters"
                                                counter
                                                @click:append="secureTextPassword = !secureTextPassword"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex class="input-wrapper">
                                            <span class="myprofile-label">{{ $t('change-password2') }}</span>
                                            <v-text-field
                                                v-model="newPassword"
                                                :append-icon="secureTextNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                :rules="[rules.required, rules.min, rules.samePassword]"
                                                :type="secureTextNewPassword ? 'password' : 'text'"
                                                name="input-10-1"
                                                hint="At least 8 characters"
                                                counter
                                                @click:append="secureTextNewPassword = !secureTextNewPassword"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-form>
                                </div>
                                <v-btn class="submit-change-pass-btn submit" text v-on:click="changePassword"
                                       :disabled="!valid2" v-if="!passwordChangeSuccess">{{ $t('change-password3') }}
                                </v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <Invoices></Invoices>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <h2>{{ $t('my-account-menu9') }}</h2>
                                <TradesHistory></TradesHistory>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div class="myprofile-container">
                                <SaleOrders :selectedSaleInvoiceId="selectedSaleInvoiceId"
                                            @triggerBackToSoldWinesPage="onTriggerBackToSoldWinesPage"></SaleOrders>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <!--                    <v-tab-item>-->
                <!--                        <v-card flat>-->
                <!--                            <v-card-text>-->
                <!--                                <div class="myprofile-container">-->
                <!--                                    <h2>Delivery orders</h2>-->
                <!--                                    <DeliveryOrders></DeliveryOrders>-->
                <!--                                </div>-->
                <!--                            </v-card-text>-->
                <!--                        </v-card>-->
                <!--                    </v-tab-item>-->
            </v-tabs>
        </div>

        <v-dialog v-model="showResetModal" max-width="570px">
            <v-card class="reset-changes-modal">
                <div class="warning-icon"></div>
                <v-card-title>Are you sure?</v-card-title>

                <v-card-text class="reset-changes-body">
                    Your changes will be lost, please confirm your intention
                </v-card-text>

                <v-card-actions>
                    <v-btn class="btn-primary btn-reset-proceed" text v-on:click="resetUserData">Proceed</v-btn>
                    <v-btn class="btn-secondary btn-reset-cancel" text v-on:click="showResetModal = false">
                        {{ $t('cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmAddressModal" max-width="500px" persistent>
            <v-card class="bids-offers-modal confirm-address-modal">
                <v-card-title>{{ $t('confirm-address05') }}</v-card-title>
                <v-card-text class="cancel-bid-body">
                    {{ $t('confirm-address06') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn class="btn-primary btn-bid-close" text v-on:click="() => { confirmAddressModal = false }">{{ $t('confirm-address03') }}</v-btn>
                    <v-btn class="btn-primary btn-bid-proceed" text v-on:click="confirmAddress">{{ $t('confirm-address04') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import API from '../services/userApiService';
import moment from 'moment';
import {mapGetters, mapActions, mapState} from 'vuex';
import {AAuth, AUser} from '@/store/actions';
import {GUser} from '@/store/getters';
import Addressbook from "./AddressbookNew";
import BankDetails from "./BankDetails";
import Favourites from "./Favourites";
import Invoices from "./Invoices";
import TradesHistory from "./TradesHistory";
import SaleOrders from "./SaleOrders";
import DeliveryOrders from "./DeliveryOrders";
import PortfolioScreen from "./PortfolioScreen";
import PortfolioScreenMobile from "./PortfolioScreenMobile";
import BidsOffersScreenMobile from "./BidsOffersScreenMobile";
import SoldWinesScreenMobile from "./SoldWinesScreenMobile";
import Notifications from "./notifications";
import Wallet from "@/components/Wallet";
import {MOrders, MPortfolio, MWines} from "@/store/mutations";
import {GCommon} from "@/store/getters";

export default {
    name: "Myprofile",
    props: {
        preselectedTab: String
    },
    head: {
        title: 'My Profile | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ]
    },
    components: {
        VFacebookLogin: () => process.client ? import('vue-facebook-login-component') : null,
        Addressbook,
        BankDetails,
        Invoices,
        TradesHistory,
        SaleOrders,
        DeliveryOrders,
        Favourites,
        PortfolioScreen,
        Notifications,
        PortfolioScreenMobile,
        BidsOffersScreenMobile,
        SoldWinesScreenMobile,
        Wallet
    },
    data() {
        return {
            vin_countries: [],
            countryMap: [],
            genders: [
                {id: 0, value: 'Male'},
                {id: 1, value: 'Female'}
            ],
            valid: true,
            confirmAddressModal: false,
            valid2: true,
            currentPassword: '',
            newPassword: '',
            secureTextPassword: true,
            secureTextNewPassword: true,
            passwordChangeSuccess: false,
            userDetailsUpdatedSuccess: false,
            userDetailsUpdatedFail: false,
            passwordChangeFail: {
                visible: false,
                text: ''
            },
            rules: {
                required: value => !!value || 'Required.',
                min: value => value.length >= 8 || 'Min 8 characters',
                samePassword: value => value != this.currentPassword || 'You cannot pick the same password'
            },
            menu: false,
            toDateText: '',
            showResetModal: false,
            country: null,
            countryError: false,
            nationality: null,
            nationalityError: false,
            isLogged: false,
            selectedTab: 0,
            list: [
                {id: 0, value: this.$i18n.t('my-investments')},
                {id: 11, value: this.$i18n.t('my-sold-wines')},
                {id: 1, value: "Wallet"},
                {id: 2, value: this.$i18n.t('my-bids')},
                {id: 3, value: this.$i18n.t('my-account-menu2')},
                {id: 4, value: this.$i18n.t('my-account-menu3')},
                {id: 5, value: this.$i18n.t('my-account-menu4')},
                {id: 6, value: this.$i18n.t('my-account-menu5')},
                {id: 7, value: this.$i18n.t('my-account-menu6')},
                {id: 8, value: this.$i18n.t('my-account-menu7')},
                {id: 9, value: this.$i18n.t('my-account-menu8')},
                {id: 10, value: this.$i18n.t('my-account-menu9')},
                {id: 11, value: this.$i18n.t('my-account-menu10')}
            ],
            tabsList: [],
            FB: {},
            fbScope: {},
            userBrowser: '',
            userDevice: '',
            selectedSaleInvoiceId: 0,
            baseUserDetails: null
        }
    },
    computed: {
        ...mapGetters({
            userData: GUser.GET_USER_DATA,
            statusKYC: GUser.GET_KYC_STATUS,
            mobileCheck: GCommon.GET_MOBILE_VERSION
        }),
        ...mapState({
            countries: state => state.countries
        }),
        dateOfBirth() {
            if (typeof this.userData.countryId !== 'undefined' && this.userData.countryId !== null) {
                let myProfileCtrl = this;
                for (let key in this.countries) {
                    if (this.countries.hasOwnProperty(key)) {
                        if (this.countries[key].id === this.userData.countryId.toString()) {
                            myProfileCtrl.country = key;
                            break;
                        }
                    }
                }
            }
            if (typeof this.userData.nationalityId !== 'undefined' && this.userData.nationalityId !== null) {
                let myProfileCtrl = this;
                for (let key in this.countries) {
                    if (this.countries.hasOwnProperty(key)) {
                        if (this.countries[key].id === this.userData.nationalityId.toString()) {
                            myProfileCtrl.nationality = key;
                            break;
                        }
                    }
                }
            }
            return this.userData.dateOfBirth === null ? '' : moment(this.userData.dateOfBirth).locale(this.$i18n.locale).format('DD MMM YYYY')
        },
        checkBankAccount() {
            return typeof this.bankDetails.iban == 'undefined';
        },
        profileName() {
            return this.userData.firstName + ' ' + this.userData.lastName
        }
    },
    methods: {
        onOpenSalesOrderDetailsPageFunc(id) {
            if (this.mobileCheck) {
                this.selectedTab = 11;
            } else {
                this.selectedTab = 10;
            }

            this.selectedSaleInvoiceId = id;
        },
        onTriggerBackToSoldWinesPage() {
            if (this.mobileCheck) {
                this.selectedTab = 12
            } else {
                this.selectedTab = 0
            }
        },
        handleSdkInit({FB, scope}) {
            this.FB = FB;
            this.fbScope = scope
        },
        formatDate(date) {
            return moment(date).locale(this.$i18n.locale).format('DD-MM-YYYY')
        },
        getCountries() {
            this.vin_countries = Object.keys(this.countries);
            this.vin_countries.forEach((code) => {
                let allCountries = this.countries,
                    newCountry = {};
                newCountry.id = allCountries[code].id;
                newCountry.code = code;
                newCountry.value = allCountries[code].value;
                this.countryMap.push(newCountry);
            })
        },
        ...mapActions({
            getData: AUser.GET_USER_DATA,
            saveData: AUser.SAVE_USER_DATA,
            confirmEmail: AUser.CONFIRM_EMAIL
        }),
        updateDetails() {
            if (!this.country) {
                this.countryError = true;
                return;
            }
            if (!this.nationality) {
                this.nationalityError = true;
                return;
            }
            this.countryError = false;
            this.nationalityError = false;

            if (this.statusKYC === 1 && (this.baseUserDetails.nationalityId !== this.countries[this.nationality].id || this.baseUserDetails.countryId !== this.countries[this.country].id || this.baseUserDetails.dateOfBirth !== this.userData.dateOfBirth)) {
                this.confirmAddressModal = true
            } else {
                this.confirmAddress()
            }
        },
        confirmAddress() {
            let payload = {
                fullName: this.userData.firstName + ' ' + this.userData.lastName,
                firstName: this.userData.firstName,
                lastName: this.userData.lastName,
                dateOfBirth: this.userData.dateOfBirth,
                gender: this.userData.gender,
                phoneNumber: this.userData.phoneNumber,
                countryId: this.countries[this.country].id,
                nationalityId: this.countries[this.nationality].id
            };

            this.$store.dispatch(AUser.SAVE_USER_DATA, payload).then(() => {
                this.userDetailsUpdatedSuccess = true;
                this.confirmAddressModal = false;
                let updateDetailsCtrl = this;

                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });

                setTimeout(function () {
                    updateDetailsCtrl.userDetailsUpdatedSuccess = false;
                }, 5000)
            }).catch(() => {
                this.userDetailsUpdatedFail = true;
                this.confirmAddressModal = false;
                let updateDetailsCtrl = this;

                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });

                setTimeout(function () {
                    updateDetailsCtrl.userDetailsUpdatedFail = false;
                }, 5000)
            });
        },
        changePassword() {
            let payload = {
                userName: this.userData.email,
                oldPassword: this.currentPassword,
                newPassword: this.newPassword,
                browser: this.userBrowser,
                device: this.userDevice
            };
            API.instance().changePass(payload).then(res => {
                this.passwordChangeSuccess = true;
                this.passwordChangeFail.visible = false;
                this.passwordChangeFail.text = '';
            }).catch(err => {
                this.passwordChangeFail.visible = true;
                this.passwordChangeFail.text = err.data[0].message;
            });
        },
        logout() {
            this.fbScope.logout();
            this.$store.dispatch(AAuth.LOG_OUT);
            this.$store.commit(MPortfolio.SET_PORTFOLIO_SUMMARY, []);
            this.$store.commit(MWines.SET_FAVOURITE_WINES_NULL);
            this.$store.commit(MOrders.SET_COLLECTION_GIFT, {
                collections: [],
                addRemove: false,
                resetCart: true,
                fromCounter: false
            });
            this.$store.commit(MOrders.SET_COLLECTION_CART, {
                collections: [],
                addRemove: false,
                resetCart: true,
                fromCounter: false
            });
            this.$store.dispatch(AUser.RESET_BANK_DETAILS);
            this.$nuxt.$emit('loggedout', 'User logged out');
            this.$router.push(this.localePath({path: '/'}));
        },
        resetUserData() {
            this.getData();
            this.showResetModal = false;
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        goToRegister() {
            this.$router.push(this.localePath({path: '/register'}));
        },
        scrollToTop() {
            window.scrollTo(0, 0)
        },
        fnBrowserDetect(){
            let userAgent = navigator.userAgent;
            let browserName;

            if (userAgent.match(/chrome|chromium|crios/i)){
                browserName = "Chrome";
            } else if(userAgent.match(/firefox|fxios/i)){
                browserName = "Firefox";
            }  else if(userAgent.match(/safari/i)){
                browserName = "Safari";
            } else if(userAgent.match(/opr\//i)){
                browserName = "Opera";
            } else if(userAgent.match(/edg/i)){
                browserName = "Edge";
            } else{
                browserName="No browser detection";
            }


            return browserName
        },
        getMobileOperatingSystem() {
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        },
        detectDeviceType() {
            let device;

            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                device = this.getMobileOperatingSystem();
            } else if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent)) {
                device = 'Tablet'
            } else {
                if (navigator.platform.indexOf('Win') !== -1) {
                    device = 'Windows'
                } else if (navigator.platform.indexOf('Mac') !== -1) {
                    device = 'Mac OS'
                } else if (navigator.platform.indexOf('Linux') !== -1) {
                    device = 'Linux'
                } else {
                    device = 'Desktop'
                }
            }

            return device
        }
    },
    mounted() {
        this.$store.dispatch(AUser.GET_KYC_STATUS);

        if (this.preselectedTab === 'settings') {
            this.selectedTab = window.innerWidth > 767 ? 3 : 4;
        } else if (this.preselectedTab === 'bank-details') {
            this.selectedTab = window.innerWidth > 767 ? 6 : 7;
        } else if (this.preselectedTab === 'profile') {
            this.selectedTab = window.innerWidth > 767 ? 4 : 5;
        } else if (this.preselectedTab === 'billing') {
            this.selectedTab = window.innerWidth > 767 ? 8 : 9;
        } else if (this.preselectedTab === 'addresses') {
            this.selectedTab = window.innerWidth > 767 ? 5 : 6;
        } else if (this.preselectedTab === 'invoices') {
            this.selectedTab = 8;
        } else if (this.preselectedTab === 'wallet') {
            this.selectedTab = 1;
        } else if (this.preselectedTab === 'trade-history') {
            this.selectedTab = 9;
        } else if (this.preselectedTab === 'sales-orders') {
            this.selectedTab = window.innerWidth > 767 ? 10 : 11;
        }

        this.$nuxt.$on('goToSection', (sectionName) => {
            if (sectionName === 'settings') {
                this.selectedTab = window.innerWidth > 767 ? 3 : 4;
            } else if (sectionName === 'portfolio') {
                this.selectedTab = 0;
            } else if (sectionName === 'wallet') {
                this.selectedTab = 1;
            } else if (sectionName === 'bank-details') {
                this.selectedTab = window.innerWidth > 767 ? 6 : 7;
            } else if (sectionName === 'profile') {
                this.selectedTab = window.innerWidth > 767 ? 4 : 5;
            } else if (sectionName === 'billing') {
                this.selectedTab = window.innerWidth > 767 ? 8 : 9;
            } else if (sectionName === 'invoices') {
                this.selectedTab = 8;
            } else if (sectionName === 'trade-history') {
                this.selectedTab = 9;
            } else if (sectionName === 'sales-orders') {
                this.selectedTab = window.innerWidth > 767 ? 10 : 11;
            }
        });

        this.tabsList = this.list;

        this.$nuxt.$on('langUpdated', () => {
            this.tabsList = [];

            this.tabsList = [
                {id: 0, value: this.$i18n.t('my-investments')},
                {id: 11, value: this.$i18n.t('my-sold-wines')},
                {id: 1, value: "Wallet"},
                {id: 2, value: this.$i18n.t('my-bids')},
                {id: 3, value: this.$i18n.t('my-account-menu2')},
                {id: 4, value: this.$i18n.t('my-account-menu3')},
                {id: 5, value: this.$i18n.t('my-account-menu4')},
                {id: 6, value: this.$i18n.t('my-account-menu5')},
                {id: 7, value: this.$i18n.t('my-account-menu6')},
                {id: 8, value: this.$i18n.t('my-account-menu7')},
                {id: 9, value: this.$i18n.t('my-account-menu8')},
                {id: 10, value: this.$i18n.t('my-account-menu9')},
                {id: 11, value: this.$i18n.t('my-account-menu10')}
            ]
        });

        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;
            this.baseUserDetails = {}
            this.baseUserDetails.nationalityId = this.userData.nationalityId
            this.baseUserDetails.countryId = this.userData.countryId
            this.baseUserDetails.dateOfBirth = this.userData.dateOfBirth
            this.getCountries();
            this.$store.dispatch(AUser.GET_BANK_DETAILS);
        }).catch(() => {
            this.isLogged = false;
        });

        this.userBrowser = this.fnBrowserDetect();
        this.userDevice = this.detectDeviceType();
    }
}
</script>

<style scoped>
.my-account .mobile-select.v-select.v-text-field {
    padding-top: 0;
    margin-top: 0;
}

.profile-name {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 19px;
    color: #000;
    margin: 20px 0 35px;
    white-space: normal;
    max-width: 250px;
    width: 100%;
    text-align: center;
}

.no-fav {
    font-size: 16px;
}

.goto-market-btn {
    margin-top: 32px;
}

.country-select {
    webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    line-height: 32px;
    padding: 0;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    border-bottom: 1px solid #b2b2b2;
    margin: 0;
    height: 50px;
    margin-top: 10px;
    margin-bottom: 8px;
    padding-left: 15px;
    font-size: 16px;
    color: #333333;
    background-color: #fff;
}

.country-select:hover {
    border-color: var(--brand);
    cursor: pointer;
}

.country-select:focus,
.country-select:active {
    border-bottom: 2px solid #000000;
}

.btn-reset-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}

.btn-reset-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.btn-reset-cancel:hover {
    color: #ffffff;
}

.reset-changes-modal {
    padding: 32px 48px;
    text-align: center;
}

.reset-changes-modal .warning-icon {
    background: url('../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.reset-changes-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

h3 {
    color: #707070;
    margin-bottom: calc(2 * var(--gutter));
}

.myprofile-label {
    position: absolute;
    font-size: var(--fs-base);
    color: #303030;
    font-weight: 300;
}

.myprofile-label-date {
    top: 0;
}

.vertical-tabs-logout {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    line-height: 19px;
    font-weight: 600;
    margin-bottom: 0;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
    color: rgba(0, 0, 0, .64);
    height: 56px;
}

.vertical-tabs-logout:hover {
    color: var(--blue) !important;
    cursor: pointer;
    background-color: var(--semi-white);
    position: relative;
}

.vertical-tabs-logout:hover::before {
    content: '';
    width: 6px;
    height: 48px;
    position: absolute;
    top: 4px;
    left: 2px;
    z-index: 100;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color: var(--blue);
}

.bank-details-wrapper {
    height: auto;
    display: block;
    width: 50%;
    border: 1px solid #CDCECD;
    border-radius: 10px;
    padding: 16px 32px;
    position: relative;
}

.bank-details-title {
    font-weight: 500;
    color: #5F605F;
    font-size: 21px;
    margin-bottom: 30px;
}

.bank-details-text {
    color: #484948;
    font-size: 16px;
}

.myprofile-wrapper {
    padding: 64px 0 0 0;
    height: calc(100% - 413px);
    background-color: var(--semi-white);
}

.myprofile-container {
    background: var(--semi-white);
    padding: 0;
    font-family: Roboto, sans-serif;
    border-radius: 4px;
}

.myprofile-container h2 {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-weight: 700;
    font-size: 35px;
    line-height: 30px;
    color: #303030;
    margin-top: 43px;
    margin-bottom: 38px;
}

.myprofile-inner-container {
    max-width: 700px;
    background: #F5F6F5;
    border-radius: 10px;
    padding: 12px 0px 28px;
}

.myacc-email-container {
    position: relative;
}

.email-confirmed {
    position: absolute;
    top: 0;
    right: 0;
}

.v-input--selection-controls {
    margin-top: 0;
}

.myacc-gender-container label {
    font-size: 12px;
}

input {
    display: block;
    width: 100%;
    font-size: 16px;
    border-bottom: 2px solid #E0E0E0;
    height: 60px;
}

label.vfl-label {
    font-size: 1em;
}

input[type="text"] {
    margin-bottom: 40px;
}

.change-pass-form {
    width: 100%;
    padding-left: 0;
}

.myprofile-wrapper .submit,
.myprofile-wrapper .addressbook-addnew-btn {
    margin-top: 30px;
    background: var(--blue) !important;
    color: #FFF !important;
    min-width: 200px;
    height: 40px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    font-weight: lighter;
    box-shadow: none;
    margin-left: 0;
    margin-right: 0;
}

.myprofile-wrapper .submit {
    margin-bottom: 50px;
}

.submit-change-pass-btn {
    background: #024E7B !important;
    border-color: #024E7B !important;
    color: #FFF !important;
    width: 140px;
    height: 38px !important;
    text-transform: none;
    font-weight: normal;
    font-size: 16px;
    margin-left: 16px;
    margin-bottom: 24px;
}

.submit-change-pass-btn.v-btn--disabled,
.submit.myprofile-submit.v-btn--disabled {
    color: #FFF !important;
    opacity: 0.5;
}

.close-change-pass-modal {
    width: 100px;
    text-transform: none;
    color: #959595 !important;
    font-weight: normal;
}

.my-profile-title {
    font-weight: 700;
    font-size: 30px;
    color: #373634;
    margin-bottom: 30px;
}

.myprofile-inner-container .v-input input {
    font-size: 20px;
    font-weight: 400;
    color: #333333;
}

.myprofile-inner-container .v-input .v-label {
    font-size: 16px;
    font-weight: 300;
}

.success-alert {
    background: #D4ECC9;
    border: 1px solid #A9DC8F;
    padding: 5px;
    text-align: center;
    color: #3B990D;
}

.fail-alert {
    background: #FF7F7F;
    border: 1px solid #FF0000;
    padding: 5px;
    text-align: center;
}

.reset-btn {
    color: rgba(0, 0, 0, .64);
    width: 50px;
    display: inline-block;
    font-size: 19px;
    text-align: center;
    margin-top: 38px;
    margin-left: 32px;
    height: 23px;
    vertical-align: top;
}

.reset-btn .link-border {
    height: 1px;
    width: 100%;
    background: #707070;
}

.reset-btn:hover {
    color: var(--blue);
    cursor: pointer;
}

.reset-btn:hover .link-border {
    background: var(--blue);
}

.bids-offers-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
}

.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}

.btn-login {
    background: #004f7f;
    border-color: #004f7f;
}

.btn-bid-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.btn-bid-cancel:hover {
    color: #ffffff;
}

.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}

.bids-offers-modal .warning-icon {
    background: url('../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.bids-title svg {
    margin-right: 5px;
    fill: #707070;
}

.offers-title svg {
    margin-right: 5px;
    fill: #707070;
}

.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

@media (max-width: 767px) {
    .myprofile-inner-container {
        margin-top: 20px;
        padding: 1px 15px 20px;
    }

    .myprofile-wrapper .submit {
        width: 100%;
        margin-bottom: 30px;
    }

    .reset-btn {
        margin-top: 0;
        margin-left: 0;
        margin-bottom: 20px;
        width: 100%;
        height: 35px;
        line-height: 35px;
    }

    .myprofile-container {
        min-height: 400px;
    }
}
</style>
<style>

.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions {
    justify-content: center;
}

.reset-changes-modal .v-card__title,
.reset-changes-modal .v-card__actions {
    justify-content: center;
}

.v-input--selection-controls .v-input__control {
    width: 100%;
}

.myacc-gender-container .v-radio {
    flex: none;
    display: inline-block;
    width: auto;
}

.myacc-gender-container .v-messages {
    display: none;
}

.my-profile-card .my-profile-tabs .v-tabs-slider {
    background-color: transparent;
}

.myprofile-wrapper .theme--light.v-input:not(.v-input--is-disabled) input:hover {
    border-color: var(--brand);
}

.theme--light.v-tabs .v-tab--disabled, .theme--light.v-tabs .v-tab:not(.v-tab--active), .theme--light.v-tabs .v-tab:not(.v-tab--active) > .v-icon {
    color: #000;
}

.my-profile-card .my-profile-tabs .v-tab {
    background: #F5F6F5;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    text-transform: capitalize;
    font-weight: normal;
    font-size: 16px;
    color: #323432;
}

.my-profile-card .my-profile-tabs .v-tab.horizontal-tab {
    border-bottom: none;
    position: relative;
    height: 32px;
}

.my-profile-card .my-profile-tabs .v-tab.v-tab--active {
    border: 1px solid #B9BAB9;
    background: #fff;
    border-bottom: none;
    position: relative;
}

.my-profile-card .my-profile-tabs .v-tab.v-tab--active:after {
    content: '';
    width: 100%;
    position: absolute;
    background: #fff;
    height: 1px;
    bottom: -1px;
    left: 0;
}

.v-tabs--icons-and-text .myprofile-wrapper .v-tabs-bar {
    height: auto;
}

.my-account-tabs-container .my-profile-card .v-slide-group__wrapper {
    max-width: 100%;
}

.my-profile-card .my-profile-vertical-tabs .v-slide-group__content {
    border: none;
}

.my-profile-card .my-profile-vertical-tabs .v-slide-group__content .v-tabs-slider-wrapper {
    display: none;
}

.theme--light.v-card.my-profile-card {
    background: var(--semi-white);
}

.theme--light.v-card.my-profile-card > .v-card__text {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
    border-bottom: 1px solid #CCCCCC;
}

.my-profile-card .v-slide-group__content {
    border-bottom: 1px solid #B9BAB9;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tabs-bar {
    max-width: 320px;
    border: none;
    padding: 0;
    background: #FFF;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab {
    color: #000000 !important;
    padding: 0;
    letter-spacing: initial;
}

.my-profile-vertical-tabs .v-card .v-card__text {
    padding: 0;
}

.my-profile-vertical-tabs .theme--light.v-card {
    background: var(--semi-white);
}

.my-profile-vertical-tabs .v-window.v-item-group.theme--light {
    padding: 0;
    padding-left: calc(3 * var(--gutter));
    padding-right: calc(3 * var(--gutter));
    background: var(--semi-white);
}

.v-tabs--vertical > .v-tabs-bar .v-tab {
    height: 56px;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab .vertical-tabs-label {
    width: 100%;
    text-align: left;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    line-height: 19px;
    font-weight: 600;
    margin-bottom: 0;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
    color: rgba(0, 0, 0, .64)
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab:hover .vertical-tabs-label,
.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab.v-tab--active .vertical-tabs-label {
    color: var(--blue) !important;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab:hover,
.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab.v-tab--active,
.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab.v-tab--active:hover .vertical-tabs-label {
    color: var(--blue) !important;
    cursor: pointer;
    background-color: var(--semi-white);
    position: relative;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab::before,
.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab:hover .vertical-tabs-label::before,
.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab.v-tab--active .vertical-tabs-label::before,
.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .v-tab.v-tab--active:hover .vertical-tabs-label::before {
    width: 6px;
    height: 48px;
    position: absolute;
    top: -16px;
    left: 2px;
    z-index: 100;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    transform: translateX(-50%);
    background-color: var(--blue);
}

.my-profile-vertical-tabs h1 {
    color: #6F706F;
    margin-bottom: calc(2.5 * var(--gutter));
    line-height: var(--fs-huge);
}

.myprofile-wrapper .v-input input {
    height: 50px;
    max-height: unset;
    margin-top: 20px;
    padding-left: 15px;
}

.myprofile-wrapper .v-input .v-label {
    color: #303030;
    font-weight: 300;
}

.myprofile-wrapper .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border: 0;
}

.myprofile-wrapper .theme--light.v-text-field > .v-input__control > .v-input__slot:after {
    border-color: var(--brand);
    border-width: 1px;
}

.myprofile-wrapper .theme--light.v-text-field.error--text > .v-input__control > .v-input__slot:after {
    border-color: #ff5252;
}

.myprofile-wrapper .myprofile-container .v-select__selections input {
    z-index: -1;
    width: 0;
    height: 0;
    margin: 0;

}

.myprofile-wrapper .myprofile-container .v-select__selections {
    line-height: 35px;
    height: 50px;
    background: #fff;
    padding-left: 15px;
    margin-top: 20px;
    border-bottom: 1px solid rgb(178, 178, 178);
}

.myprofile-wrapper .myprofile-container .v-select__selections:hover {
    border-color: var(--brand);
}

.myprofile-wrapper .myprofile-container .v-select__selections input {
    width: 0
}

.myprofile-wrapper .myprofile-container .v-text-field .v-input__append-inner {
    align-self: center;
    position: absolute;
    z-index: 7;
    right: 0;
    top: 30px;
}

.back-order {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 16px;
    font-weight: 300;
    color: #b2b2b2;
}

.back-order svg {
    fill: #b2b2b2;
    margin-left: 5px;
}

.back-order:hover {
    color: var(--brand);
    cursor: pointer;
}

.back-order:hover svg {
    fill: var(--brand);
}

.myprofile-wrapper .myprofile-container .address-book-items .addresscard-container {
    height: auto;
    display: block;
    width: 100%;
    border: 1px solid #CDCECD;
    border-radius: 10px;
}

.myprofile-wrapper .myprofile-container .addressbook-container {
    margin: 0;
    max-width: 100%;
}

.myprofile-wrapper .change-pass-form .v-input .v-label {
    font-size: 18px;
}

.myprofile-wrapper .change-pass-form .v-icon.v-icon.v-icon--link {
    right: 15px;
    position: absolute;
}

.myprofile-wrapper .change-pass-form .submit-change-pass-btn {
    margin: 0;
}

.theme--light.v-tabs.my-profile-vertical-tabs .v-tab:hover:before {
    opacity: 0;
}

.theme--light.v-tabs.my-profile-vertical-tabs .v-tab:hover {
    color: var(--brand)
}

.myprofile-wrapper .flex {
    margin-top: 20px;
}

.myprofile-wrapper .v-text-field__details {
    display: none;
}

.myprofile-wrapper .myprofile-inner-container .change-pass-form .v-text-field__details {
    display: flex;
}

.country-container.myprofile-country .myprofile-label {
    -webkit-transform: translateY(-18px) scale(.75);
    transform: translateY(-18px) scale(.75);
    height: 20px;
    line-height: 20px;
    position: relative;
}

.country-select.error-msg {
    border-bottom: 1px solid red !important;
}

.my-account .mobile-select .v-text-field__details,
.my-account .mobile-select.v-select.v-text-field input {
    display: none;
}

.my-account .mobile-select .v-input__slot {
    margin-bottom: 0;
}

.my-account .mobile-select.v-select > .v-input__control > .v-input__slot {
    height: 50px;
    font-size: 17px;
    padding: 0 15px;
    border-bottom: 1px solid;
}

.my-account .mobile-select.v-text-field > .v-input__control > .v-input__slot:after,
.my-account .mobile-select.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border: 0;
}

.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__title{
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 16px;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions {
    padding: 20px 16px 24px;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close {
    flex: 1 0 0;
    border-radius: 8px;
    border: 2px solid #004F7F;
    background: transparent;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    margin-right: 0;
    height: 51px;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close .v-btn__content {
    color: #004F7F;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed {
    border-radius: 8px;
    background: #004F7F;
    border: 2px solid #004F7F;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    flex: 1 0 0;
    margin-left: 0;
    height: 51px;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed .v-btn__content {
    color: #FFF;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}

@media (max-width: 767px) {
    .theme--light.v-card.my-profile-card > .v-card__text {
        padding: 15px;
    }

    .myprofile-wrapper .myprofile-container .address-book-items .addresscard-container {
        background-color: var(--semi-white);
    }
}
</style>
